import { useEffect, useState } from "react";
import { useApiClient } from "../../api";
import { useAuthenticationStore } from "../../stores/auth";
import { useHelpStore } from "../../stores/help";
import { introductionOwner, shouldShowSignupPurpose } from "./signupPurpose";

// Mounted only for an authenticated, eligible role with a sign-in identity.
export function IntroductionTrigger({ user, blocked, pathname, panel }) {
  const api = useApiClient();
  const [loaded, setLoaded] = useState(null);
  const owner = introductionOwner(user);
  useEffect(() => {
    let active = true;
    api.users
      .getOnboarding()
      .then((state) => {
        if (active) setLoaded({ owner, state });
      })
      .catch(() => {
        // Optional guidance must not interrupt the app or retry on every render.
        if (active)
          useAuthenticationStore
            .getState()
            .markIntroductionSeen(user.signInSession, user.info.id);
      });
    return () => {
      active = false;
    };
  }, [api, owner]);

  useEffect(() => {
    if (
      loaded?.owner === owner &&
      shouldShowSignupPurpose(user, loaded.state, { blocked, pathname, panel })
    ) {
      useHelpStore.getState().openIntroduction();
    }
  }, [loaded, owner, user, blocked, pathname, panel]);
  return null;
}
